import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { InputType } from 'enums/InputType';
import { KeepExistingProductPlanOnDiscontinuationSettingDtoModel } from 'models/generated/Models.KeepExistingProductPlanOnDiscontinuationSettingDto';
import { SelectListItemModel } from 'models/SelectList';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'keep-existing-product-plan-on-discontinuation',
	templateUrl: './keep-existing-product-plan-on-discontinuation.component.html',
	imports: [DataTableComponent, DataRowComponent, CustomSelectComponent, TranslatePipe]
})
export class KeepExistingProductPlanOnDiscontinuationComponent {

	@Input() setting!: KeepExistingProductPlanOnDiscontinuationSettingDtoModel;
	@Input('tags') selectListTags: SelectListItemModel[] = [];
	@Output() settingChange = new EventEmitter<KeepExistingProductPlanOnDiscontinuationSettingDtoModel>();

	inputTypeEnum = InputType;

	valueChange() {
		this.settingChange.emit(this.setting);
	}
}
